import * as React from "react";
import {Badge, Button} from "react-bootstrap";
import {FormattedMessage} from "react-intl";

interface OutdatedWarningProperties {
  numberOfNewDataItems: number;
  numberOfRemovedDataItems: number;
  numberOfNewFolders: number;
  numberOfRemovedFolders: number;
  refreshLinkClicked: () => void;
  messageType: string;
}

export class OutdatedWarningPresentation extends React.Component<OutdatedWarningProperties, {}> {

  render() {
    const {numberOfNewDataItems, numberOfRemovedDataItems, numberOfNewFolders, numberOfRemovedFolders, refreshLinkClicked, messageType} = this.props;
    if (numberOfNewDataItems === 0 && numberOfRemovedDataItems === 0 && numberOfNewFolders === 0 && numberOfRemovedFolders === 0) {
      return null;
    }

    switch (messageType) {
    case "data":
      return (
          <div className="outdatedWarning">
            {numberOfNewDataItems > 0 && (
                <span>
                  <FormattedMessage id="studio.outdated-warning.new-data-available" defaultMessage="New data available"/>
                  <Badge>{numberOfNewDataItems}</Badge>
                </span>
            )}
            {numberOfRemovedDataItems > 0 && (
                <span style={{marginLeft: 8}}>
                  <FormattedMessage id="studio.outdated-warning.removed-data-available" defaultMessage="Data has been removed"/>
                  <Badge>{numberOfRemovedDataItems}</Badge>
                </span>
            )}
            {numberOfNewFolders > 0 && (
                <span style={{marginLeft: 8}}>
                  <FormattedMessage id="studio.outdated-warning.new-folders-available" defaultMessage="New folders available"/>
                  <Badge>{numberOfNewFolders}</Badge>
                </span>
            )}
            {numberOfRemovedFolders > 0 && (
                <span style={{marginLeft: 8}}>
                  <FormattedMessage id="studio.outdated-warning.removed-folders-available" defaultMessage="Folders have been removed"/>
                  <Badge>{numberOfRemovedFolders}</Badge>
                </span>
            )}
            <Button
                bsSize="xsmall"
                bsStyle="warning"
                onClick={() => {
                  refreshLinkClicked();
                }}>
              <FormattedMessage id="studio.outdated-warning.refresh-button" defaultMessage="Refresh Now"/>
            </Button>
          </div>
      );
      case "style":
      return (
          <div className="outdatedWarning">
          <span><FormattedMessage id="studio.outdated-warning.new-styles-available"
                                  defaultMessage="New styles available"/><Badge>{numberOfNewDataItems}</Badge></span>
            <Button bsSize="xsmall" onClick={() => {
              refreshLinkClicked();
              // No need to define a default message for this key because it's already defined above, we just want to use same message here.
            }}><FormattedMessage id="studio.outdated-warning.refresh-button" defaultMessage="Refresh Now"/></Button>
          </div>
      );
    }

  }
}
